import type { CollectableItem } from "../collectableItem";
import { type TintConfig, type Tintable } from "../interfaces";
import { Ammo } from "../items/ammo";
import { deserializeItem, deserializeXY } from "../serialization";
import { Jetpack } from "../weapons/jetpack";
import type { XY } from "../xy";
import { LootBox } from "./lootBox";

export class JetpackLootBox extends LootBox implements Tintable {
	static key = "JetpackLootBox";

	constructor(xy: XY, loot: CollectableItem[] = [new Ammo(Jetpack.key, Jetpack.CHARGES_PER_BOX)]) {
		super(xy, loot);
	}

	getTint(): TintConfig | null {
		return { r: 255, g: 255, b: 255, minAlpha: 0.0, maxAlpha: 0.3 };
	}

	getAnimationSpeedMultiplier(): number {
		return 1.0;
	}

	static deserialize(data: any): JetpackLootBox {
		const box = new JetpackLootBox(deserializeXY(data.xy));
		box.visualId = data.visualId;
		if (data.loot) {
			box.loot = data.loot.map((d: any) => deserializeItem(d));
		}
		return box;
	}
}
